import {LightingPattern, MoodLight} from '../../../../types';
import {BasicExclusiveOrCustomMoodLight, Scratchpad} from '../../Scratchpad';
import {HexColorTriplet} from '../../pikaparam';

export type HeatCycleTarget =
  | 'tempHeatCycle'
  | 'heatCycle0'
  | 'heatCycle1'
  | 'heatCycle2'
  | 'heatCycle3';

export type Target = 'lantern' | HeatCycleTarget;

export interface ReadLightOptions {
  target: Target;
}

export type ColorLight = {color: HexColorTriplet; pattern?: LightingPattern};

export type ReadLight = BasicExclusiveOrCustomMoodLight | ColorLight;
export interface ReadLightResult {
  light: ReadLight;
  metadata?: Scratchpad;
}

export type WriteLight = MoodLight | ColorLight;
export interface WriteLightOptions {
  target: Target;
  light: WriteLight;
  metadata?: Scratchpad;
}

export const isBasicMoodLight = (
  light: ReadLight,
): light is BasicExclusiveOrCustomMoodLight =>
  !!(light as BasicExclusiveOrCustomMoodLight).category;

export const isMoodLight = (light: WriteLight): light is MoodLight =>
  !!(light as MoodLight).category;

export interface IUnitLedApi {
  readActiveLedArray(): Promise<number[]>;
  setPartyMode(): Promise<void>;
  readLight(options: ReadLightOptions): Promise<ReadLightResult>;
  writeLight(options: WriteLightOptions): Promise<void>;
}
